import './signin.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Member from 'src/entities/Member';

import { resetPasswordEmail, signinMember } from '../../actions/member';
import CancelWhite from '../../res/img/cancel_white.svg';
import Illustration from '../../res/img/signin.png';

interface IProps {
  account: Member;
  signinMember: (member: Member) => void;
  resetPasswordEmail: (member: Member) => void;
}

interface IState {
  id: string;
  password: string;
  resetPasswordShown: boolean;
  resetPasswordKey: string;
}

class SigninComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      id: '',
      password: '',
      resetPasswordShown: false,
      resetPasswordKey: ''
    };

    this.signin = this.signin.bind(this);
    this.onChangeId = this.onChangeId.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.showResetPassword = this.showResetPassword.bind(this);
    this.hideResetPassword = this.hideResetPassword.bind(this);
    this.onChangeResetPasswordKey = this.onChangeResetPasswordKey.bind(this);
    this.resetPasswordEmail = this.resetPasswordEmail.bind(this);
  }

  render() {
    if (this.props.account.id !== undefined) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: location.pathname }
          }}
        />
      );
    }
    return (
      <div id="AccountSignin">
        <div id="Background">
          <img src={Illustration} />
        </div>
        <div id="SigninForm">
          <input
            className="InputText"
            value={this.state.id}
            onChange={this.onChangeId}
            placeholder="従業員コードを半角数字で入力"
          />
          <input
            type="password"
            className="InputText"
            value={this.state.password}
            onChange={this.onChangePassword}
            placeholder="パスワードを入力"
          />

          <button id="Signin" onMouseUp={this.signin} onTouchEnd={this.signin}>
            ログイン
          </button>

          <div
            id="ResetPasswordTrigger"
            onMouseUp={this.showResetPassword}
            onTouchEnd={this.showResetPassword}
          >
            パスワードを忘れた
          </div>
        </div>
        {this.state.resetPasswordShown ? (
          <div id="ReserPasswordFormContainer">
            <div className="Background" />
            <div id="ReserPasswordForm">
              <input
                className="InputText"
                value={this.state.resetPasswordKey}
                onChange={this.onChangeResetPasswordKey}
                placeholder="従業員コードを半角数字で入力してください"
              />
              <button
                onMouseUp={this.resetPasswordEmail}
                onTouchEnd={this.resetPasswordEmail}
              >
                メールを送信
              </button>

              <div
                className="Cancel"
                onMouseUp={this.hideResetPassword}
                onTouchEnd={this.hideResetPassword}
              >
                <img src={CancelWhite} />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onChangeId(e: any) {
    this.setState({
      id: e.target.value
    });
  }

  onChangePassword(e: any) {
    this.setState({
      password: e.target.value
    });
  }

  onChangeResetPasswordKey(e: any) {
    this.setState({
      resetPasswordKey: e.target.value
    });
  }

  resetPasswordEmail(e: any) {
    if (this.state.resetPasswordKey.length > 0) {
      this.setState({
        resetPasswordShown: false,
        resetPasswordKey: ''
      });
      const member = new Member();
      member.id = Number(this.state.resetPasswordKey);
      this.props.resetPasswordEmail(member);
    }
  }

  signin(e: any) {
    const member = new Member();
    member.id = Number(this.state.id);
    member.password = this.state.password;

    this.props.signinMember(member);
  }

  showResetPassword(e: any) {
    this.setState({
      resetPasswordShown: true
    });
  }
  hideResetPassword(e: any) {
    this.setState({
      resetPasswordShown: false
    });
  }
}

const mapStateToProps = (state: any) => ({
  account: state.Account
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    signinMember(member: Member) {
      dispatch(signinMember(member));
    },
    resetPasswordEmail(member: Member) {
      dispatch(resetPasswordEmail(member));
    }
  };
};

const Memo = connect(
  mapStateToProps,
  mapDispatchToProps
)(SigninComponent);

export default Memo;



// WEBPACK FOOTER //
// ./src/components/Account/signin.tsx